(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13013,2610,40659,81066,75847,44709,40852,81243,74453,44954,40617],{

/***/ 54638:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-consulting-services",
      function () {
        return __webpack_require__(27560);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Breadcrumbs/styles.module.scss
var styles_module = __webpack_require__(51701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/utils/useBreadcrumbs.js



/* harmony default export */ function useBreadcrumbs(param) {
    var className = param.className, _breadcrumbs = param.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, dark = param.dark;
    var classNames = classnames_default()((styles_module_default()).breadcrumbs, className, (0,_define_property/* default */.Z)({}, (styles_module_default()).dark, dark));
    return {
        className: classNames,
        breadcrumbs: breadcrumbs
    };
};

;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Breadcrumbs = function(props) {
    var ref = useBreadcrumbs(props), breadcrumbs = ref.breadcrumbs, className = ref.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        "aria-label": "breadcrumbs",
        className: className,
        children: breadcrumbs.map(function(param, i) {
            var to = param.to, title = param.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50 * i,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        path: to,
                        className: classnames_default()((styles_module_default()).item, (0,_define_property/* default */.Z)({}, (styles_module_default()).activeItem, i === breadcrumbs.length - 1)),
                        children: title
                    })
                }))
            }, to);
        })
    });
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().instanceOf(Array).isRequired,
    className: (prop_types_default()).string,
    dark: (prop_types_default()).bool
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 2610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26033);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42222);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);











var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var PageHeader = function(param) {
    var title = param.title, breadcrumbs = param.breadcrumbs, titleStyles = param.titleStyles, breadcrumbsStyles = param.breadcrumbsStyles, breadcrumbsTheme = param.breadcrumbsTheme, updatedAt = param.updatedAt, type = param.type, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                breadcrumbs: breadcrumbs,
                className: breadcrumbsStyles,
                type: type,
                dark: breadcrumbsTheme === "dark"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().titleContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, titleStyles, titleStyles), className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                    children: [
                        updatedAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().updatedAt),
                            children: "Last updated: ".concat((0,utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .formatDate */ .p6)(updatedAt))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: title
                        }),
                        children
                    ]
                }))
            })
        ]
    });
};
PageHeader.defaultProps = {
    title: "",
    breadcrumbs: null,
    titleStyles: "",
    breadcrumbsStyles: ""
};
PageHeader.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbs: prop_types__WEBPACK_IMPORTED_MODULE_10___default().instanceOf(Array),
    titleStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbsStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 96604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var UI_components_PageHeader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2610);
/* harmony import */ var UI_components_AiEngineeringPodBadge__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96038);
/* harmony import */ var components_Common_MetaTags__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38067);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96076);
/* harmony import */ var redux_apis_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85144);
/* harmony import */ var utils_breadcrumbs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84047);
/* harmony import */ var utils_routes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27727);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11277);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
















var FullScreenEstimation = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 92261).then(__webpack_require__.bind(__webpack_require__, 92261));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92261)
            ];
        }
    },
    ssr: false
});
var AppDevelopmentCommon = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 74584).then(__webpack_require__.bind(__webpack_require__, 74584)).then(function(module) {
        return module.AppDevelopmentCommon;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74584)
            ];
        }
    }
});
var CustomServiceContainer = function(param) {
    var introSection = param.introSection, metaData = param.metaData, type = param.type, ssrContentModules = param.contentModules;
    var ref = (0,redux_apis_page__WEBPACK_IMPORTED_MODULE_4__/* .useFetchPageQuery */ .oO)(type, {
        skip: Boolean(ssrContentModules)
    }), _data = ref.data, data = _data === void 0 ? {} : _data;
    var contentModules = ssrContentModules !== null && ssrContentModules !== void 0 ? ssrContentModules : data.contentModules;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFullscreenEstimation = ref1[0], setIsFullscreenEstimation = ref1[1];
    var breadcrumbs = (0,utils_breadcrumbs__WEBPACK_IMPORTED_MODULE_5__/* .getBreadcrumbs */ .Z)(type);
    var pageMetadata = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, metaData), {
        url: "".concat(utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .rootUrl */ .Wd, "/").concat(type)
    });
    var breadcrumbsTheme = utils_constants__WEBPACK_IMPORTED_MODULE_9__/* .PAGES_WITH_DARK_BREADCRUMBS.includes */ .nq.includes(type) ? "dark" : null;
    var openFullscreenEstimation = function() {
        return setIsFullscreenEstimation(true);
    };
    var closeFullscreenEstimation = function() {
        return setIsFullscreenEstimation(false);
    };
    if (!contentModules) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_MetaTags__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                page: type,
                pageMetadata: pageMetadata,
                breadcrumbs: breadcrumbs
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default())[type]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_PageHeader__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        breadcrumbs: breadcrumbs,
                        titleStyles: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageTitle),
                        breadcrumbsStyles: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().breadcrumbs),
                        breadcrumbsTheme: breadcrumbsTheme
                    }),
                    contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(module) {
                        var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_8__/* .getDocumentFields */ .OA)(module) || {}, sectionType = ref.type, view = ref.view, slug = ref.slug;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppDevelopmentCommon, {
                            section: module,
                            handleOnCTAClick: openFullscreenEstimation,
                            type: type,
                            introSection: introSection
                        }, "".concat(type, "/").concat(sectionType, "-").concat(view || slug));
                    }),
                    type !== utils_routes__WEBPACK_IMPORTED_MODULE_13__/* .routes.aiManagedPod.slug */ ._.aiManagedPod.slug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_AiEngineeringPodBadge__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenEstimation, {
                isFullscreenEstimation: isFullscreenEstimation,
                closeFullscreenEstimation: closeFullscreenEstimation
            })
        ]
    });
};
CustomServiceContainer.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomServiceContainer);


/***/ }),

/***/ 27560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var containers_CustomService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96604);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (containers_CustomService__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 51701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__U7jAD","item":"styles_item__WAV19","activeItem":"styles_activeItem__Sdvlz","dark":"styles_dark__9MzT_"};

/***/ }),

/***/ 42222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"styles_titleContainer__EQ1kE","updatedAt":"styles_updatedAt__pww8i"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ }),

/***/ 11277:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BBgOb","pageTitle":"styles_pageTitle__6J6DJ","breadcrumbs":"styles_breadcrumbs__REsC5","chat-app-development-company":"styles_chat-app-development-company__yDANj","feedbackContainer":"styles_feedbackContainer__QVLBu","book-a-call":"styles_book-a-call__5nZYk","enterprise-resource-planning-software-services":"styles_enterprise-resource-planning-software-services__MTKTS","web-app-development-company":"styles_web-app-development-company__7DnCl","ios-mobile-app-development-services":"styles_ios-mobile-app-development-services__cT8iT","android-mobile-app-development-services":"styles_android-mobile-app-development-services__uaKWD","mvp-app-development-company":"styles_mvp-app-development-company__xKP89","pwa-development-services":"styles_pwa-development-services__ADaih","cloud-based-app-development-services":"styles_cloud-based-app-development-services__GCh5_","machine-learning-development-services":"styles_machine-learning-development-services__LpHz5","fintech-software-development-services":"styles_fintech-software-development-services__GMDUV","devops-development-services":"styles_devops-development-services__sMT5M","data-science-development-company":"styles_data-science-development-company__uNCuB","cross-platform-development-services":"styles_cross-platform-development-services__rRoUo","artificial-intelligence-development-services":"styles_artificial-intelligence-development-services__qjmyG","prototyping-services":"styles_prototyping-services__nVrsQ","software-quality-assurance-services":"styles_software-quality-assurance-services___XYOv","software-development-columbus":"styles_software-development-columbus__RYlen","software-development-new-orleans":"styles_software-development-new-orleans__9hUwO","software-development-tulsa":"styles_software-development-tulsa__UGrzV","software-development-minneapolis":"styles_software-development-minneapolis__LMpgJ","software-development-omaha":"styles_software-development-omaha___QyEB","software-development-miami":"styles_software-development-miami__kpovf","software-development-washington":"styles_software-development-washington__6LStr","software-development-nashville":"styles_software-development-nashville__PnZKr","software-development-raleigh":"styles_software-development-raleigh__DqDJr","software-development-oklahoma":"styles_software-development-oklahoma__Pk9Ry","generative-ai-services":"styles_generative-ai-services__1UX7Z","deep-learning":"styles_deep-learning__4Ry_k","ai-staff-augmentation-services":"styles_ai-staff-augmentation-services___Qzcc","ai-consulting-services":"styles_ai-consulting-services__PvYGh","ai-chatbot-development-services":"styles_ai-chatbot-development-services__jFoZD","computer-vision-services":"styles_computer-vision-services__oHka5","natural-language-processing-as-a-service":"styles_natural-language-processing-as-a-service__b8jNr","robotic-process-automation-services":"styles_robotic-process-automation-services__xC0Bg","software-development-services-for-startups":"styles_software-development-services-for-startups__1b610","ai-agent-development-services":"styles_ai-agent-development-services__QGon_","rag-development-services":"styles_rag-development-services__kF_yV","ai-managed-pod":"styles_ai-managed-pod__5EjMI","mlops-development-services":"styles_mlops-development-services__YVqmq","penetration-testing":"styles_penetration-testing__t6Rl5","banking-software-development-company":"styles_banking-software-development-company__Cb_Iw","delivery-quality-in-yellow":"styles_delivery-quality-in-yellow__be0kE","payment-gateway-development-company":"styles_payment-gateway-development-company__02w_l","e-wallet-app-development":"styles_e-wallet-app-development__PGVkK","billing-software-development-services":"styles_billing-software-development-services__KNjLj","logistics-software-development-services":"styles_logistics-software-development-services__ywyK5","e-commerce-development":"styles_e-commerce-development__l7dil","david-vs-goliath":"styles_david-vs-goliath__bdAwz","beyond-the-hype":"styles_beyond-the-hype__gK7vN","llm-use-cases-webinar":"styles_llm-use-cases-webinar__79wZ7","beyond-chatbots-webinar":"styles_beyond-chatbots-webinar__xaXca","llm-development-services":"styles_llm-development-services__uJ7oC","ai-voice-assistant-development-services":"styles_ai-voice-assistant-development-services__SOdIo","ai-copilot-development-services":"styles_ai-copilot-development-services__3MJyr","mobile-app-development-company":"styles_mobile-app-development-company__9atNa"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [24168,6778,57330,13107,24438,49774,92888,40179], function() { return __webpack_exec__(54638); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);